import {useLang} from '../../../_metronic/i18n/Metronici18n'
import {PageTitle} from '../../../_metronic/layout/core'

function Codap() {
  const lang = useLang()

  return (
    <>
      <PageTitle breadcrumbs={[]}>Codap</PageTitle>
      <div className='card card-custom gx-xl-10 mt-lg-n16 mt-2'>
        <div className='card-header p-2'>
          {/*
          <iframe
            title='CODAP'
            src={`https://codap.concord.org/releases/latest/static/dg/${lang}/cert/index.html`}
            width='100%'
            height='800px'
            className='rounded'
          />
  {*/}
          <iframe
            src={`${process.env.PUBLIC_URL}/codap/index.html`}
            width='100%'
            height='800px'
            className='rounded'
            title='Codap'
          />
        </div>
      </div>
    </>
  )
}

export default Codap
